<template>
  <div class="onebox">
    <drag-modal :visible="$store.state.dislog.ones" @cancel="reset" :title='"添加进度-" + litetit' width='840px'
      :class='{ "editbox": Edit }'>
      <div class="navbox" v-if='Edit'>
        <Nscroll @getIndex='see' @delCopy='copydel' :openEdit='openEdit'></Nscroll>
        <div class="intopbtn" v-if='!isAllDis'>
          <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
            StepLite != 181 && $store.state.DisForm.infoList &&
            $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
          ">
            <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
          </a-popconfirm>
          <a-button icon="edit"
            v-if='$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower'
            style="margin-left:10px;" @click='openEdit = !openEdit'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
        </div>
      </div>
      <div class="warning-tips" v-if="form.agent.length == 0 && Edit">
        <span>注：系统针对代理人模块进行了架构更新，检测到当前进度的代理人相关信息需要完善，请完善信息后提交</span>
      </div>
      <a-spin :spinning="loading">
        <a-form-model ref="forms" :model="form" :rules="openEdit ? {} : rules" :label-col="{ span: 10 }"
          :wrapper-col="{ span: 24 }">
          <div class="oneadd nonebox">
            <div class="ant-form-item-control" v-if="StepLite == 70 || StepLite == 115" style="padding-bottom: 10px;">
              <a-form-model-item prop="appellee_type" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                <a-button v-if="openEdit" type="primary">{{ form.appellee_type == 1 ? '原告' : '被告' }}{{ StepLite == 70 ?
                  "上诉" : "申请" }}</a-button>
                <a-radio-group v-model="form.appellee_type" button-style="solid" v-else>
                  <a-radio-button :value="1">原告{{ StepLite == 70 ? "上诉" : "申请" }}</a-radio-button>
                  <a-radio-button :value="2">被告{{ StepLite == 70 ? "上诉" : "申请" }}</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </div>
            <div class="nbg" v-if='StepLite == 70 || StepLite == 115' style="margin-bottom: 10px;">
              <a-row :gutter="24">
                <a-col :span='6'>
                  <a-form-model-item :label="StepLite == 115 ? '申请人' : '上诉人'" prop="appellor"
                    :rules="{ required: true, message: StepLite == 115 ? '请选择申请人' : '请选择上诉人', trigger: 'change' }">
                    <Selsee v-if="openEdit" :list="withList" :ids="form.appellor"></Selsee>
                    <a-select v-model="form.appellor" :placeholder="!openEdit ? StepLite == 115 ? '请选择申请人' : '请选择上诉人' : ''" mode="multiple" show-search
                      :filter-option="filterOption" v-else>
                      <a-select-option v-for='(i) in withList' :key='i.id'>{{ i.title }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span='6'>
                  <a-form-model-item :label="StepLite == 115 ? '被申请人' : '被上诉人'" prop="appellee"
                    :rules="{ required: true, message: StepLite == 115 ? '请选择被申请人' : '请选择被上诉人', trigger: 'change' }">
                    <Selsee v-if="openEdit" :list="withList" :ids="form.appellee"></Selsee>
                    <a-select v-model="form.appellee" :placeholder="!openEdit ? StepLite == 115 ? '请选择被申请人' : '请选择被上诉人' : ''" v-else mode="multiple"
                      show-search :filter-option="filterOption">
                      <a-select-option v-for='(i) in withList' :key='i.id'>{{ i.title }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span='6'>
                  <a-form-model-item label="法院地区：" prop="court"
                    :rules="{ required: true, message: '请选择法院地区', trigger: 'change' }">
                    <a-cascader :options="options" :placeholder="!openEdit ? '请选择法院地区' : ''" change-on-select
                      :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model='form.court'
                      @change='seachCourtList(form.court); form.court_id = null' :disabled='openEdit' />
                  </a-form-model-item>
                </a-col>
                <a-col :span='6'>
                  <a-form-model-item label="管辖法院：" prop="court_id"
                    :rules="{ required: true, message: '请选择管辖法院', trigger: 'change' }">
                    <a-select show-search v-model="form.court_id" :placeholder="!openEdit ? '请选择管辖法院' : ''"
                      :allowClear='true' :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                      :not-found-content="null" :disabled='openEdit'>
                      <a-select-option v-for="d in courtList" :key="d.id">
                        {{ d.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
            <div class="newtypelist">
              <div class="li">
                <a-form-model-item label="费用模式：" prop='cost_model'
                  :rules="{ required: true, message: '请选择费用模式', trigger: 'change' }">
                  <a-select v-model="form.cost_model" placeholder="请选择费用模式" :disabled='openEdit'>
                    <a-select-option v-for="row in costmodelList" :key="row.id" :value="row.id">{{ row.option_name
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="li">
                <a-form-model-item label="代理模式：" prop='agent_model'
                  :rules="{ required: true, message: '请选择代理模式', trigger: 'change' }">
                  <a-select v-model="form.agent_model" :placeholder="!openEdit ? '请选择代理模式' : ''" @change="agentmodelChange"
                    :disabled='openEdit'>
                    <a-select-option v-for="row in agentmodelList" :key="row.id" :value="row.id">{{ row.option_name
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="li">
                <a-form-model-item :label="StepLite == 121 ? '代理人：' : '立案代理人：'" prop='agent'
                  :rules="{ required: true, message: StepLite == 121 ? '请选择代理人' : '请选择立案代理人', trigger: 'change' }">
                  <a-select v-model="form.agent" :placeholder="!openEdit ? StepLite == 121 ? '请选择代理人' : '请选择立案代理人' : ''" mode="multiple"
                    :disabled='openEdit'>
                    <a-select-option v-for="row in agentList" :key="row.id" :value="row.id"
                      :disabled="row.status == 0">{{ row.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
            </div>
            <a-form-model-item label="案号：" v-if="StepLite == 121"
              :rules="{ required: false, message: '请输入案号', trigger: 'blur' }" style="padding-bottom:10px;width:250px;">
              <a-input v-model="form.no" :disabled='openEdit' :placeholder="!openEdit ? '请输入案号' : ''" />
            </a-form-model-item>
            <a-form-model-item :label="(StepLite == 121 ? '申请' : '立案') + '方式：'" class="ckbox">
              <div class="li" v-for="(i, index) in plainOptions" :key="index" :class="{ 'cur': i.value == form.type }"
                @click="!openEdit ? ck(i.value) : ''">{{ i.label }}</div>
              <!-- <a-radio-group :options="plainOptions" v-model="form.type" @change='qtype' :disabled='openEdit' /> -->
            </a-form-model-item>
            <div class="newtypelist">
              <div class="li" v-if='form.type == 1'>
                <a-form-model-item label="平台名称" prop="platform"
                  :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }" style="margin-bottom:10px;">
                  <a-auto-complete :data-source="data" style="width: 100%;" v-model='form.platform'
                    @search="handleSearch" :placeholder="!openEdit ? '请输入平台名称' : ''" :disabled='openEdit' />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 1'>
                <a-form-model-item label="材料提交时间：" prop="time"
                  :rules="{ required: true, message: '请选择材料提交时间', trigger: 'change' }">
                  <a-date-picker v-model="form.time" :placeholder="!openEdit ? '请选择材料提交时间' : ''" style="width: 100%;"
                    show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 2'>
                <a-form-model-item label="单号：" prop="ship_no" style="margin-bottom:10px;"
                  :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                  <a-input v-model="form.ship_no" :disabled='openEdit' :placeholder="!openEdit ? '请输入单号' : ''" />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 2'>
                <a-form-model-item label="联系方式：" prop="tel" style="margin-bottom:10px;"
                  :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                  <a-input v-model="form.tel" :disabled='openEdit' :placeholder="!openEdit ? '请输入联系方式' : ''" />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 2'>
                <a-form-model-item label="材料名称：" prop="filename"
                  :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                  <a-input v-model="form.filename" :disabled='openEdit' :placeholder="!openEdit ? '请输入材料名称' : ''" />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 2'>
                <a-form-model-item label="收件人：" prop="receive_name"
                  :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                  <a-input v-model="form.receive_name" :disabled='openEdit' :placeholder="!openEdit ? '请输入收件人' : ''" />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 2'>
                <a-form-model-item label="寄出时间：" prop="ship_time" style="margin-bottom:10px;"
                  :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                  <a-date-picker v-model="form.ship_time" :placeholder="!openEdit ? '请选择寄出时间' : ''" style="width: 100%;"
                    show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss'
                    :disabled='openEdit' />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 2'>
                <a-form-model-item label="">
                  <label v-if='openEdit'>{{ form.gout == "a" ? "签收时间:" : (form.gout == "b" ? "拒收时间:" : "无") }}</label>
                  <a-radio-group v-model='form.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                    v-else>
                    <a-radio-button :value="null"
                      style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                    <a-radio-button :value="'a'"
                      style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                    <a-radio-button :value="'b'"
                      style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                  </a-radio-group>
                  <a-date-picker v-model="form.receive_time" :placeholder="!openEdit ? '请选择' : ''" show-time
                    valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='form.gout == "a"'
                    :disabled='openEdit' style="width:100%;" />
                  <a-date-picker v-model="form.return_time" :placeholder="!openEdit ? '请选择' : ''" show-time
                    valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                    style="width:100%;" v-if='form.gout == "b"' />
                  <a-input disabled v-if='!form.gout' />
                </a-form-model-item>
              </div>
              <!-- 
              <div class="li" v-if='form.type==2'>
                <a-form-model-item label="签收时间" prop="receive_time" :rules="{ required: false, message: '请选择签收时间',trigger: 'change'}" :label-col="{span: 10}" :wrapper-col="{span: 20}">
                  <a-date-picker v-model="form.receive_time" placeholder="请选择" style="width: 100%;" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                </a-form-model-item>
              </div> -->
              <div class="li" v-if='form.type == 3'>
                <a-form-model-item :label="(StepLite == 121 ? '申请' : '立案') + '时间'" prop="time"
                  :rules="{ required: true, message: StepLite == 121 ? '请选择申请时间' : '请选择立案时间', trigger: 'change' }">
                  <a-date-picker v-model="form.time" :placeholder="!openEdit ? StepLite == 121 ? '请选择申请时间' : '请选择立案时间' : ''" style="width: 100%;"
                    show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 3'>
                <a-form-model-item :label="(StepLite == 121 ? '申请' : '立案') + '地点'" prop="location"
                  :rules="{ required: true, message: StepLite == 121 ? '请输入申请地点' : '请输入立案地点', trigger: 'blur' }">
                  <a-input v-model="form.location" :disabled='openEdit' :placeholder="!openEdit ? StepLite == 121 ? '请输入申请地点' : '请输入立案地点' : ''" />
                </a-form-model-item>
              </div>
              <div class="li" v-if='form.type == 3'>
                <a-form-model-item label="提交人" prop="submiter"
                  :rules="{ required: true, message: '请输入我方提交人', trigger: 'blur' }">
                  <a-input v-model="form.submiter" :disabled='openEdit' :placeholder="!openEdit ? '请输入我方提交人' : ''" />
                </a-form-model-item>
              </div>

              <!-- <div class="li" v-if="form.type > 0">
                <a-form-model-item label="联系人及方式：" prop='court_tel' style="margin-top:10px;"
                  :rules="{ required: false, message: '请输入立案联系方式', trigger: 'blur' }">
                  <a-input style="width:100%;" v-model="form.court_tel" placeholder="请输入联系人及方式" :disabled='openEdit' />
                </a-form-model-item>
              </div> -->
              <div class="li" v-if='form.type == 2' style="width:33.3%;">
                <a-form-model-item label="收件地址：" prop="addr"
                  :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                  <a-input v-model="form.addr" :disabled='openEdit' :placeholder="!openEdit ? '请输入收件地址' : ''"
                    style="width:100%;" />
                </a-form-model-item>
              </div>

              <div class="li" v-if="StepLite == 15">
                <a-form-model-item label="仲裁机构地区：">
                  <a-cascader :options="options" :placeholder="!openEdit ? '请选择仲裁机构地区' : ''" change-on-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model="arb" @change="
                      seachArbList(arb)
                    form.arb_org_id = null
                      " />
                </a-form-model-item>
              </div>
              <div class="li" v-if="StepLite == 15">
                <a-form-model-item label="仲裁机构：" prop='arb_org_id' :rules="{ required: false, trigger: 'change' }">
                  <a-select show-search v-model="form.arb_org_id" :placeholder="!openEdit ? '请选择仲裁机构' : ''"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
                    :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null">
                    <a-select-option v-for="d in arbList" :key="d.id">
                      {{ d.title }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
            </div>
            <div class="newtypelist">
              <div class="li" v-if='StepLite == 10 || StepLite == 130'>
                <a-form-model-item label="法院地区：" prop="court"
                  :rules="{ required: true, message: '请选择法院地区', trigger: 'change' }">
                  <a-cascader :options="options" :placeholder="!openEdit ? '请选择法院地区' : ''" change-on-select
                    :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model='form.court'
                    @change='seachCourtList(form.court); form.court_id = null' :disabled='openEdit' />
                </a-form-model-item>
              </div>
              <div class="li" v-if='StepLite == 10 || StepLite == 130'>
                <a-form-model-item label="管辖法院：" prop="court_id"
                  :rules="{ required: true, message: '请选择管辖法院', trigger: 'change' }">
                  <a-select show-search v-model="form.court_id" :placeholder="!openEdit ? '请选择管辖法院' : ''"
                    :allowClear='true' :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null" :disabled='openEdit'>
                    <a-select-option v-for="d in courtList" :key="d.id">
                      {{ d.title }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="li" v-if='StepLite == 121'>
                <a-form-model-item label="时间" prop="case_time"
                  :rules="{ required: true, message: '请选择时间', trigger: 'change' }">
                  <a-date-picker v-model="form.case_time" :placeholder="!openEdit ? '请选择时间' : ''" style="width: 100%"
                    type="date" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" :disabled="openEdit" />
                </a-form-model-item>
              </div>
              <div class="li" v-if='StepLite == 121'>
                <a-form-model-item label="阶段" prop="case_stage"
                  :rules="{ required: true, message: '请选择阶段', trigger: 'change' }">
                  <a-select v-model="form.case_stage" :placeholder="!openEdit ? '请选择阶段' : ''" :disabled="openEdit">
                    <a-select-option :value="1" v-if="$store.state.cause.cause_type == 1">诉讼</a-select-option>
                    <a-select-option :value="2" v-else>仲裁</a-select-option>
                    <a-select-option :value="3">执行</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="li" v-if='StepLite == 121'>
                <a-form-model-item label="原因" prop="reason"
                  :rules="{ required: true, message: '请选择原因', trigger: 'change' }">
                  <a-select v-model="form.reason" :placeholder="!openEdit ? '请选择原因' : ''" :disabled="openEdit">
                    <a-select-option :value="0">请选择</a-select-option>
                    <a-select-option :value="1">{{ StepLite != 125 ? `${ygName}申请` : ($store.state.cause.cause_type == 1
                      ? '法院依职权'
                      : '调解中心依职权'
                    ) }}</a-select-option>
                    <a-select-option :value="2">{{ StepLite != 125 ? `${bgName}申请` : `${ygName}申请` }}</a-select-option>
                    <a-select-option :value="3">{{ StepLite != 125 ? '法院移送' : `${bgName}申请` }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="li" v-if='StepLite == 121'>
                <a-form-model-item label="承办人" prop="undertaker"
                  :rules="{ required: false, message: '请输入承办人', trigger: 'blur' }">
                  <a-input type="text" :placeholder="!openEdit ? '请输入承办人' : ''" v-model="form.undertaker"
                    :disabled="openEdit"></a-input>
                </a-form-model-item>
              </div>
              <div class="li" v-if='StepLite == 121'>
                <a-form-model-item label="联系方式" prop="undertaker_tel"
                  :rules="{ required: false, message: '请输入联系方式', trigger: 'blur' }">
                  <a-input type="text" :placeholder="!openEdit ? '请输入联系方式' : ''" v-model="form.undertaker_tel"
                    :disabled="openEdit"></a-input>
                </a-form-model-item>
              </div>
            </div>
            <div class="li" style="width:100%;">
              <a-form-model-item label="备注：" prop="comments"
                :rules="{ required: false, message: '请输入备注', trigger: 'blur' }" v-if="StepLite == 121">
                <Textarea :content='form.comments' @contentVal='(element) => { form.comments = element }'
                  :edit='openEdit' :keyArr="['time', 'user']" v-if='!loading'> </Textarea>
              </a-form-model-item>
              <a-form-model-item label="备注：" prop="comment"
                :rules="{ required: false, message: '请输入备注', trigger: 'blur' }" v-else>
                <Textarea :content='form.commentList' @contentVal='reContent' :more="false" :edit='openEdit'
                  v-if='!loading' :keyArr="['comment_time', 'comment_user']"> </Textarea>
              </a-form-model-item>
            </div>
            <a-divider />

            <div class="licter" v-if='!openEdit'>
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click='plusAdd(1)'>电子</a>
                <a href="javascript:void(0);" @click='plusAdd(2)'>微信</a>
                <a href="javascript:void(0);" @click='plusAdd(3)'>现场</a>
                <a href="javascript:void(0);" @click='plusAdd(4)'>邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for='(i, index) in form.supp' :key='index'>
                <div class="likebox" v-if='i.type == 1'>
                  <div class="htit">补充材料：电子
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'"
                        :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                        <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                        :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 2'>
                  <div class="htit">补充材料：微信
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'"
                        :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                        <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                        :rules="{ required: true, message: '请输入补充时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请输入补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 3'>
                  <div class="htit">
                    补充材料：现场
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'"
                        :rules="{ required: true, message: '请输入补充提交人', trigger: 'blur' }">
                        <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入补充提交人"/>
                      </a-form-model-item>
                    </a-col>

                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                        :rules="{ required: true, message: '请输入补充时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请输入补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 4'>
                  <div class="htit">
                    补充材料：邮寄
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'"
                        :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                        <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'"
                        :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                        <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'"
                        :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                        <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入收件人"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'"
                        :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="">
                        <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                        <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                          v-else>
                          <a-radio-button :value="null"
                            style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                          <a-radio-button :value="'a'"
                            style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                          <a-radio-button :value="'b'"
                            style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                          :disabled='openEdit' style="width:100%;" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" v-if='i.gout == "b"' />
                        <a-input disabled v-if='!i.gout' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='12'>
                      <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'"
                        :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                        <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='12'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if='!openEdit'>
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click='plusAdd(1, 1)'>电子</a>
                <a href="javascript:void(0);" @click='plusAdd(2, 1)'>微信</a>
                <a href="javascript:void(0);" @click='plusAdd(3, 1)'>现场</a>
                <a href="javascript:void(0);" @click='plusAdd(4, 1)'>邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for='(i, index) in form.accept_file' :key='index'>
                <div class="likebox" v-if='i.type == 1'>
                  <div class="htit">接收材料：电子
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'"
                        :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                        <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                        :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 2'>
                  <div class="htit">接收材料：微信
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'"
                        :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                        <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                        :rules="{ required: true, message: '请输入接收时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请输入接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 3'>
                  <div class="htit">
                    接收材料：现场
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'"
                        :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                        <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入接收人"/>
                      </a-form-model-item>
                    </a-col>

                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                        :rules="{ required: true, message: '请输入接收时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请输入接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 4'>
                  <div class="htit">
                    接收材料：邮寄
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'"
                        :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                        <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'"
                        :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                        <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'"
                        :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                        <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入接收人"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'"
                        :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="">
                        <label v-if='openEidt'>{{ i.gout == "a" ? "签收时间" : (i.gout == "b" ? "拒收时间" : "无") }}</label>
                        <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                          v-else>
                          <a-radio-button :value="null"
                            style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                          <a-radio-button :value="'a'"
                            style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                          <a-radio-button :value="'b'"
                            style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                        </a-radio-group>

                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                          :disabled='openEdit' style="width:100%;" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" v-if='i.gout == "b"' />
                        <a-input disabled v-if='!i.gout' />
                      </a-form-model-item>

                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='12'>
                      <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'"
                        :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                        <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='12'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <!-- <a-form-model-item label="文书生效时间" prop="judgment_valid_time" :rules="{ required: false, message: '请输入文书生效时间',trigger: 'change'}" style="padding-bottom:20px;" v-if='StepLite==130'>
              <a-date-picker v-model="form.judgment_valid_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
            </a-form-model-item> -->
            <a-form-model-item prop="files" :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
              <Upload @isDisabled="parentHandle" :fList='List' @upFileAfter='lisUpload' :disabled="openEdit" :edit='openEdit' v-if='!loading'
                :Wid='"72px"' />
            </a-form-model-item>
          </div>
          <a-form-model-item v-if='!openEdit' style="text-align:center;">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button :disabled="disabledShow" type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
      <!-- <See></See> -->
    </drag-modal>
  </div>
</template>
<script>
import Upload from "@/components/uploads"
import { oneAdd, oneEdit, lasczDetails, servenAdd, servenEdit, with_debtor, addAgentinfo, editAgentinfo, delAgentinfo, delJd } from "@/server/speed"
import { getDirectory, arbOrg, attorneyoptions } from "@/server/directory"
import Nscroll from "@/components/nscroll"
import { stepFiles } from "@/server/debtor"
import liteKey from "./../liteKey.json"
import { mapGetters, mapActions } from 'vuex'
import Textarea from "@/components/textarea"
import Selsee from '@/components/selsee'
import fy from "../fy"
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
export default {
  name: "Ones",
  props: {
    agentmodelList: Array,
    costmodelList: Array,
  },
  components: {
    Upload, Nscroll, Textarea, Selsee
  },
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
    ygName() {
      return this.$store.state.cause.cause_type == 1 ? '原告' : '申请人'
    },
    bgName() {
      return this.$store.state.cause.cause_type == 1 ? '被告' : '被申请人'
    },
    formKey() {
      const keyArr = ["platform", "time", "ship_no", "receive_time", "supp", "files", "accept_file", "court_tel", "type", "ship_time", "submiter", 'location', 'filename', 'receive_name', 'addr', 'tel', 'gout', 'return_time', 'cost_model', 'agent', 'agent_model',];
      if (this.StepLite == 70 || this.StepLite == 115) {
        keyArr.push("appellor", "appellee", 'appellee_type')
      }
      if (this.StepLite == 121) {
        keyArr.push('no')
        keyArr.push("comments")
        keyArr.push("case_time")
        keyArr.push("case_stage")
        keyArr.push("reason")
        keyArr.push("undertaker")
        keyArr.push("undertaker_tel")
      }
      if (this.StepLite == 130) {
        keyArr.push("judgment_valid_time")
      }
      if (this.StepLite != 121) {
        keyArr.push('comment', 'comment_time', 'comment_user', 'commentList')
        if (this.StepLite == 15) {
          keyArr.push('arb_org_id')
        } else {
          keyArr.push("court", "court_id")
        }
      }
      return keyArr
    }
  },
  data() {
    return {
      List: [],
      arb: [],
      options: citySort(city),
      StepLite: this.$store.state.StepLite,
      isAllDis: this.$route.query.t,
      loading: true,
      fy,
      plainOptions: [
        { label: '网立', value: 1 },
        { label: '邮寄', value: 2 },
        { label: '现场', value: 3 },
      ],
      data: [],
      courtList: [],
      withList: [],
      form: {
        appellee_type: null,
        commentList: [{}],
        comment: '',
        comments: [{}],
        court_id: '',
        comment_time: '',
        comment_user: '',
        type: 1,      //补充材料类型    
        platform: null,    //平台名称
        time: null,        //时间
        ship_no: null,     //单号
        ship_time: null,   //签收时间
        supp: [],       //补充材料数组
        accept_file: [],
        files: [],    //附件
        court_tel: null,
        submiter: null,
        location: null,
        gout: null,
        arb_org_id: null,
        cost_model: undefined,
        stage: '',
        stage_inside: '',
        stage_outside: '',
        agent: [],
        agent_model: undefined,

      },
      arbList: [],
      rules: {},
      openEdit: false,
      disabledShow: false,
      agentList: [],
      agent_model: '',
      old_agent_model: '',
      old_agent: []
    }
  },
  created() {
    if (this.StepLite == 70 || this.StepLite == 115) {
      with_debtor({ id: this.$store.state.cause.id }).then(e => {
        this.withList = e.list
      })
    }
    if (this.Edit) {
      this.$nextTick(() => {
        lasczDetails({ cause_id: this.$store.state.cause.id, step: this.StepLite }).then(e => {
          e.list.map(ele => {
            ele.lascz.supp = Object.keys(ele.lascz.supp).map(key => ele.lascz.supp[key])
            ele.lascz.accept_file = Object.keys(ele.lascz.accept_file).map(key => ele.lascz.accept_file[key])
            ele.lascz.court = ele.lascz.courte ? [ele.lascz.courte.province_id, ele.lascz.courte.city_id, ele.lascz.courte.area_id] : [110000]
            this.seachCourtList(ele.lascz.court)
            if (this.StepLite == 70 || this.StepLite == 115) {
              ele.lascz.appellor = ele.lascz.appellor.split(",")
              ele.lascz.appellee = ele.lascz.appellee.split(",")
            }
            if (this.StepLite != 121) {
              ele.lascz.commentList = [{ "content": ele.lascz.comment, "comment_user": ele.lascz.comment_user, "comment_time": ele.lascz.comment_time }]
            } else {
              ele.lascz.comments = !ele.lascz.comments || (ele.lascz.comments && ele.lascz.comments.length == 0) ? [{}] : ele.lascz.comments
            }
            if (this.StepLite == 15) {
              const arb = ele.lascz.arb_org
              const arbList = [arb.province_id, arb.city_id, arb.area_id].filter(ele => { return ele })
              this.arb = arbList
              this.seachArbList(arbList)
            }
          })
          e.list.map(ele => {
            ele.lascz.supp.map(element => {
              for (let val in element) {
                if (!element[val]) {
                  delete element[val]
                }
              }
              if (element.type * 1 == 4) {
                element.gout = (!this.pickTime(element.receive_time) && !this.pickTime(element.return_time)) ? null : (element.receive_time ? "a" : "b")
              }
            })
            ele.lascz.accept_file.map(element => {
              for (let val in element) {
                if (!element[val]) {
                  delete element[val]
                }
              }
              if (element.type * 1 == 4) {
                element.gout = (!this.pickTime(element.receive_time) && !this.pickTime(element.return_time)) ? null : (element.receive_time ? "a" : "b")
              }
            })
          })
          this.$store.dispatch("settime", e.list[0].lascz.update_time)
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
        })
      })
      this.openEdit = true;
    } else {
      this.loading = false;
    }
  },
  methods: {
    agentmodelChange(e) {
      if (e == this.old_agent_model) {
        this.form.agent = this.old_agent
      } else {
        this.form.agent = []
      }
      this.agentmodelList.map(item => {
        if (item.id == e) {
          this.getatt(item.id)
        }
      })
    },
    getatt(id) {
      attorneyoptions(id).then(res => {
        this.agentList = res
      })
    },
    parentHandle(data) {
      this.disabledShow = data
    },
    pickTime(val) {
      if (!val || !/^\d{4}([\/-])\d{2}([\/-])\d{2}([\sT:\-\d]+)$/.test(val) || val == '0000-00-00 00:00:00') return ''
      else {
        return val
      }
    },
    ck(id) {
      if (this.StepLite != 10) {
        if (id == this.form.type) {
          return
        } else {
          this.form.type = id
        }
      } else {
        this.form.type = id
      }
    },
    reContent(val) {
      this.form.comment = val[0].content;
      this.form.comment_user = val[0].comment_user;
      this.form.comment_time = val[0].comment_time;
    },
    gtLetter() {
      return (JSON.parse(localStorage.getItem("pName")) || []).concat(this.fy).filter(ele => { return ele })
    },
    handleSearch(value) {
      this.data = !value ? [] : this.gtLetter().filter(ele => { return ele.indexOf(value) >= 0 });
    },
    seachCourtList(val) {      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : '';
      getDirectory({ province_id: province_id, city_id: city_id, area_id: area_id }).then(e => {
        this.courtList = e.list
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {        //删除进度
      await this.Newdel({ index: index, formKey: this.formKey, valkey: "lascz" }).then(e => {
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    see(index) {        //查看切换 审批
      this.loading = true;
      this.seeInfo({ index: index, formKey: this.formKey, valkey: "lascz" }).then(e => {
        let form = JSON.parse(JSON.stringify(e));
        form.files.map((ele) => {
          ele.title = ele.origin_name || ele.title
          ele.upload_id = ele.upload_id
          ele.id = ele.id
        })
        this.List = form.files
        if (form.agent == null || form.agent == NaN) {
          form.agent = []
        }
        if (form.agent_model == 0 || form.agent_model == 3 || form.agent_model == 4 || form.agent_model == 10) {
          form.agent_model = ''
        } else {
          form.agent_model = Number(form.agent_model)
        }
        this.old_agent_model = form.agent_model
        this.old_agent = form.agent
        this.agentmodelList.map(item => {
          if (item.id == form.agent_model) {
            this.getatt(item.id)
          }
        })
        if (form.cost_model == 0) {
          form.cost_model = ''
        } else {
          form.cost_model = Number(form.cost_model)
        }
        form.receive_time = this.pickTime(form.receive_time)
        form.return_time = this.pickTime(form.return_time)
        form.gout = (!form.receive_time && !form.return_time) ? null : (form.receive_time ? "a" : "b")
        this.form = form
        this.loading = false;
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
    qtype(e, val) {     //切换清除
      let keyArr = ["platform", "time", "ship_no", "ship_time"]
      keyArr.map(ele => {
        this.form[ele] = null
      })
      this.$refs.forms.clearValidate(keyArr);
    },
    seachArbList(val) {
      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : ''
      arbOrg({
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }, 'index').then((e) => {
        this.arbList = e.list
      })
    },
    removeEmptyValues(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];

          // 检查值是否存在/不为空（根据需求调整条件）
          if (value !== undefined && value !== null && value !== '') {
            // 如果是对象，递归处理
            if (typeof value === 'object' && !Array.isArray(value)) {
              const cleanedObj = removeEmptyValues(value);
              if (Object.keys(cleanedObj).length > 0) {
                result[key] = cleanedObj;
              }
            } else {
              result[key] = value;
            }
          }
        }
      }

      return result;
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = this.removeEmptyValues(JSON.parse(JSON.stringify(this.form)));
          if (form.gout == "a") {
            form.return_time = null
          } else if (form.gout == "b") {
            form.receive_time = null
          } else {
            form.return_time = null
            form.receive_time = null
          }
          delete form.commentList
          delete form.gout

          if (this.StepLite == 70 || this.StepLite == 115) {
            form.appellor = form.appellor.join(",")
            form.appellee = form.appellee.join(",")
          }
          form.supp.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          if (form.no) {
            form.no = form.no.replace(/\s/g, '');
          }
          form.files = form.files.map(ele => {
            return ele.upload_id || ele
          })
          if (form.comments) {
            form.comments = form.comments.filter(ele => { return ele.content })
          }
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd = this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ? true : false   //当前是否是在修改下的新增
          form.step = this.StepLite
          if (this.StepLite != 15) delete form.arb_org_id
          if (this.StepLite == 130) {
            form.stage = '执行阶段'
          } else if (this.StepLite == 121) {
            form.stage = '审判监督'
            if (form.case_stage == 1) {
              form.stage_inside = '诉讼'
            } else if (form.case_stage == 2) {
              form.stage_inside = '仲裁'
            } else if (form.case_stage == 3) {
              form.stage_inside = '执行'
            }
            form.stage_outside = ''
          } else {
            if (this.$store.state.cause.cause_type == 1) {
              form.stage = '诉讼阶段'
            } else {
              form.stage = '仲裁阶段'
            }
          }
          if (this.StepLite == 130) {
            form.stage_outside = '无'
          } else if (this.StepLite == 10) {
            form.stage_outside = '一审'
          } else if (this.StepLite == 70) {
            form.stage_outside = '二审'
          } else if (this.StepLite == 115) {
            form.stage_outside = '再审'
          }
          if (this.StepLite != 121) {
            form.stage_inside = '立案'
          }
          if (this.Edit && !isEditCopyAdd) {      //修改
            let id = this.$store.state.DisForm.infoList[curIndex].lascz.id
            form.id = id;
            oneEdit(form, this.StepLite).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.setKey()
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            oneAdd(form, this.StepLite).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })`
              this.setKey()
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    setKey() {
      let letter = JSON.parse(localStorage.getItem("pName")) || []
      if (this.gtLetter().indexOf(this.form.platform) < 0) {
        letter.push(this.form.platform)
        localStorage.setItem("pName", JSON.stringify(letter))
      }
    },
    reset() {
      this.reMove().then(e => {
        this.form = {
          type: 1,      //补充材料类型    
          platform: null,    //平台名称
          time: null,        //时间
          ship_no: null,     //单号
          ship_time: null,   //签收时间
          accept_file: [],
          supp: [],       //补充材料数组
          files: [],    //附件
          court_tel: null,
          submiter: null,
          location: null,
          gout: 'a',
          cost_model: null,
          agent: [],
          agent_model: null
        }
        this.$store.dispatch('openkey', { key: 'ones', by: false })
      })
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    }
  }
}
</script>
<style lang="less" scoped>
.ckbox {
  overflow: hidden;

  .li {
    float: left;
    background: url('../../../assets/img/ico.png') no-repeat left center;
    background-size: 15px 15px;
    font-size: 0.75rem;
    padding-right: 20px;
    padding-left: 20px;
    cursor: pointer;
  }

  .cur {
    background-image: url('../../../assets/img/icoh.png');
  }
}

.newtypelist {
  margin: 0 -12px;
  display: flex;
  flex-wrap: wrap;

  .li {
    width: 33.3%;
    display: inline-block;
    padding: 0 12px;
  }
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }
}

.nonebox {
  .ant-form-item {
    margin: 0 !important;
  }

  /deep/ .ant-form-explain {
    // position: absolute;/
  }
}

.oneadd {
  margin-bottom: 20px;
}

.ilikecon {
  max-height: 400px;
  overflow: auto;
  margin-top: 20px;
}

.licter {
  overflow: hidden;
  margin: 20px 0;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>